/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var shared_pb = require('./shared_pb.js');
goog.exportSymbol('proto.fleet.CreateOwnUserRequest', null, global);
goog.exportSymbol('proto.fleet.CreateOwnUserResponse', null, global);
goog.exportSymbol('proto.fleet.GetApprovalStatusResponse', null, global);
goog.exportSymbol('proto.fleet.GetUserMetadataByIdData', null, global);
goog.exportSymbol('proto.fleet.GetUserMetadataByIdRequest', null, global);
goog.exportSymbol('proto.fleet.GetUserMetadataByIdResponse', null, global);
goog.exportSymbol('proto.fleet.OpAreaApprovalStatus', null, global);
goog.exportSymbol('proto.fleet.PolicyAgreementTypes', null, global);
goog.exportSymbol('proto.fleet.PushTokenType', null, global);
goog.exportSymbol('proto.fleet.RequestSiteAccessRequest', null, global);
goog.exportSymbol('proto.fleet.RequestSiteAccessResponse', null, global);
goog.exportSymbol('proto.fleet.UpdateApprovalStatusRequest', null, global);
goog.exportSymbol('proto.fleet.UpdateApprovalStatusResponse', null, global);
goog.exportSymbol('proto.fleet.UpdatePushTokenRequest', null, global);
goog.exportSymbol('proto.fleet.UpdatePushTokenResponse', null, global);
goog.exportSymbol('proto.fleet.UpdateUserSummaryRequest', null, global);
goog.exportSymbol('proto.fleet.UpdateUserSummaryResponse', null, global);
goog.exportSymbol('proto.fleet.UserAccountStatus', null, global);
goog.exportSymbol('proto.fleet.UserAgreement', null, global);
goog.exportSymbol('proto.fleet.UserApprovalStatus', null, global);
goog.exportSymbol('proto.fleet.UserExists', null, global);
goog.exportSymbol('proto.fleet.UserExistsResponse', null, global);
goog.exportSymbol('proto.fleet.UserId', null, global);
goog.exportSymbol('proto.fleet.UserIdResponse', null, global);
goog.exportSymbol('proto.fleet.UserProfile', null, global);
goog.exportSymbol('proto.fleet.UserProfileResponse', null, global);
goog.exportSymbol('proto.fleet.UserSummary', null, global);
goog.exportSymbol('proto.fleet.UserType', null, global);
goog.exportSymbol('proto.fleet.UserTypeResponse', null, global);
goog.exportSymbol('proto.fleet.UsersByIdRequest', null, global);
goog.exportSymbol('proto.fleet.UsersRequest', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserExists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UserExists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserExists.displayName = 'proto.fleet.UserExists';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserExists.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserExists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserExists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserExists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserExists}
 */
proto.fleet.UserExists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserExists;
  return proto.fleet.UserExists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserExists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserExists}
 */
proto.fleet.UserExists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserExists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserExists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserExists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserExists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.UserExists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.fleet.UserExists.prototype.setExists = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserAgreement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UserAgreement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserAgreement.displayName = 'proto.fleet.UserAgreement';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserAgreement.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserAgreement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserAgreement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserAgreement.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserAgreement}
 */
proto.fleet.UserAgreement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserAgreement;
  return proto.fleet.UserAgreement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserAgreement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserAgreement}
 */
proto.fleet.UserAgreement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fleet.PolicyAgreementTypes} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserAgreement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserAgreement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserAgreement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserAgreement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional PolicyAgreementTypes type = 1;
 * @return {!proto.fleet.PolicyAgreementTypes}
 */
proto.fleet.UserAgreement.prototype.getType = function() {
  return /** @type {!proto.fleet.PolicyAgreementTypes} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.fleet.PolicyAgreementTypes} value */
proto.fleet.UserAgreement.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.fleet.UserAgreement.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.UserAgreement.prototype.setVersion = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserExistsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.UserExistsResponse.oneofGroups_);
};
goog.inherits(proto.fleet.UserExistsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserExistsResponse.displayName = 'proto.fleet.UserExistsResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.UserExistsResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.UserExistsResponse.UserExistsOneOfCase = {
  USER_EXISTS_ONE_OF_NOT_SET: 0,
  USEREXISTS: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.UserExistsResponse.UserExistsOneOfCase}
 */
proto.fleet.UserExistsResponse.prototype.getUserExistsOneOfCase = function() {
  return /** @type {proto.fleet.UserExistsResponse.UserExistsOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.UserExistsResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserExistsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserExistsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserExistsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserExistsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    userexists: (f = msg.getUserexists()) && proto.fleet.UserExists.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserExistsResponse}
 */
proto.fleet.UserExistsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserExistsResponse;
  return proto.fleet.UserExistsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserExistsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserExistsResponse}
 */
proto.fleet.UserExistsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.UserExists;
      reader.readMessage(value,proto.fleet.UserExists.deserializeBinaryFromReader);
      msg.setUserexists(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserExistsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserExistsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserExistsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserExistsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserexists();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.UserExists.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserExists userexists = 1;
 * @return {?proto.fleet.UserExists}
 */
proto.fleet.UserExistsResponse.prototype.getUserexists = function() {
  return /** @type{?proto.fleet.UserExists} */ (
    jspb.Message.getWrapperField(this, proto.fleet.UserExists, 1));
};


/** @param {?proto.fleet.UserExists|undefined} value */
proto.fleet.UserExistsResponse.prototype.setUserexists = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.UserExistsResponse.oneofGroups_[0], value);
};


proto.fleet.UserExistsResponse.prototype.clearUserexists = function() {
  this.setUserexists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserExistsResponse.prototype.hasUserexists = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.UserExistsResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.UserExistsResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.UserExistsResponse.oneofGroups_[0], value);
};


proto.fleet.UserExistsResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserExistsResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UserType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserType.displayName = 'proto.fleet.UserType';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserType.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserType.toObject = function(includeInstance, msg) {
  var f, obj = {
    oride: jspb.Message.getFieldWithDefault(msg, 1, false),
    commandor: jspb.Message.getFieldWithDefault(msg, 2, false),
    syncstation: jspb.Message.getFieldWithDefault(msg, 3, false),
    command: jspb.Message.getFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserType}
 */
proto.fleet.UserType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserType;
  return proto.fleet.UserType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserType}
 */
proto.fleet.UserType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOride(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCommandor(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSyncstation(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCommand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOride();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCommandor();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getSyncstation();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCommand();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool oride = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.UserType.prototype.getOride = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.fleet.UserType.prototype.setOride = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool commandor = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.UserType.prototype.getCommandor = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.fleet.UserType.prototype.setCommandor = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool syncstation = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.UserType.prototype.getSyncstation = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.fleet.UserType.prototype.setSyncstation = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool command = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.UserType.prototype.getCommand = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.fleet.UserType.prototype.setCommand = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserTypeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.UserTypeResponse.oneofGroups_);
};
goog.inherits(proto.fleet.UserTypeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserTypeResponse.displayName = 'proto.fleet.UserTypeResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.UserTypeResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.UserTypeResponse.UsertypeOneOfCase = {
  USERTYPE_ONE_OF_NOT_SET: 0,
  USERTYPE: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.UserTypeResponse.UsertypeOneOfCase}
 */
proto.fleet.UserTypeResponse.prototype.getUsertypeOneOfCase = function() {
  return /** @type {proto.fleet.UserTypeResponse.UsertypeOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.UserTypeResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserTypeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserTypeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserTypeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserTypeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usertype: (f = msg.getUsertype()) && proto.fleet.UserType.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserTypeResponse}
 */
proto.fleet.UserTypeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserTypeResponse;
  return proto.fleet.UserTypeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserTypeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserTypeResponse}
 */
proto.fleet.UserTypeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.UserType;
      reader.readMessage(value,proto.fleet.UserType.deserializeBinaryFromReader);
      msg.setUsertype(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserTypeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserTypeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserTypeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserTypeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsertype();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.UserType.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserType usertype = 1;
 * @return {?proto.fleet.UserType}
 */
proto.fleet.UserTypeResponse.prototype.getUsertype = function() {
  return /** @type{?proto.fleet.UserType} */ (
    jspb.Message.getWrapperField(this, proto.fleet.UserType, 1));
};


/** @param {?proto.fleet.UserType|undefined} value */
proto.fleet.UserTypeResponse.prototype.setUsertype = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.UserTypeResponse.oneofGroups_[0], value);
};


proto.fleet.UserTypeResponse.prototype.clearUsertype = function() {
  this.setUsertype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserTypeResponse.prototype.hasUsertype = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.UserTypeResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.UserTypeResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.UserTypeResponse.oneofGroups_[0], value);
};


proto.fleet.UserTypeResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserTypeResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.UserSummary.repeatedFields_, null);
};
goog.inherits(proto.fleet.UserSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserSummary.displayName = 'proto.fleet.UserSummary';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.UserSummary.repeatedFields_ = [6,7,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    allowText: jspb.Message.getFieldWithDefault(msg, 4, false),
    phone: jspb.Message.getFieldWithDefault(msg, 5, ""),
    operatingAreaIdsList: jspb.Message.getRepeatedField(msg, 6),
    approvalStatusList: jspb.Message.getRepeatedField(msg, 7),
    hasAllowText: jspb.Message.getFieldWithDefault(msg, 8, false),
    policyAgreementsList: jspb.Message.toObjectList(msg.getPolicyAgreementsList(),
    proto.fleet.UserAgreement.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserSummary}
 */
proto.fleet.UserSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserSummary;
  return proto.fleet.UserSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserSummary}
 */
proto.fleet.UserSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowText(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 6:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setOperatingAreaIdsList(value);
      break;
    case 7:
      var value = /** @type {!Array<!proto.fleet.UserApprovalStatus>} */ (reader.readPackedEnum());
      msg.setApprovalStatusList(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasAllowText(value);
      break;
    case 9:
      var value = new proto.fleet.UserAgreement;
      reader.readMessage(value,proto.fleet.UserAgreement.deserializeBinaryFromReader);
      msg.addPolicyAgreements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAllowText();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOperatingAreaIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      6,
      f
    );
  }
  f = message.getApprovalStatusList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getHasAllowText();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getPolicyAgreementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.fleet.UserAgreement.serializeBinaryToWriter
    );
  }
};


/**
 * optional string first_name = 1;
 * @return {string}
 */
proto.fleet.UserSummary.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.UserSummary.prototype.setFirstName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string last_name = 2;
 * @return {string}
 */
proto.fleet.UserSummary.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.UserSummary.prototype.setLastName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.fleet.UserSummary.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.UserSummary.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool allow_text = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.UserSummary.prototype.getAllowText = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.fleet.UserSummary.prototype.setAllowText = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string phone = 5;
 * @return {string}
 */
proto.fleet.UserSummary.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.fleet.UserSummary.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated int32 operating_area_ids = 6;
 * @return {!Array<number>}
 */
proto.fleet.UserSummary.prototype.getOperatingAreaIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<number>} value */
proto.fleet.UserSummary.prototype.setOperatingAreaIdsList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.fleet.UserSummary.prototype.addOperatingAreaIds = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


proto.fleet.UserSummary.prototype.clearOperatingAreaIdsList = function() {
  this.setOperatingAreaIdsList([]);
};


/**
 * repeated UserApprovalStatus approval_status = 7;
 * @return {!Array<!proto.fleet.UserApprovalStatus>}
 */
proto.fleet.UserSummary.prototype.getApprovalStatusList = function() {
  return /** @type {!Array<!proto.fleet.UserApprovalStatus>} */ (jspb.Message.getRepeatedField(this, 7));
};


/** @param {!Array<!proto.fleet.UserApprovalStatus>} value */
proto.fleet.UserSummary.prototype.setApprovalStatusList = function(value) {
  jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.fleet.UserApprovalStatus} value
 * @param {number=} opt_index
 */
proto.fleet.UserSummary.prototype.addApprovalStatus = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


proto.fleet.UserSummary.prototype.clearApprovalStatusList = function() {
  this.setApprovalStatusList([]);
};


/**
 * optional bool has_allow_text = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.UserSummary.prototype.getHasAllowText = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.fleet.UserSummary.prototype.setHasAllowText = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * repeated UserAgreement policy_agreements = 9;
 * @return {!Array<!proto.fleet.UserAgreement>}
 */
proto.fleet.UserSummary.prototype.getPolicyAgreementsList = function() {
  return /** @type{!Array<!proto.fleet.UserAgreement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.UserAgreement, 9));
};


/** @param {!Array<!proto.fleet.UserAgreement>} value */
proto.fleet.UserSummary.prototype.setPolicyAgreementsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.fleet.UserAgreement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.UserAgreement}
 */
proto.fleet.UserSummary.prototype.addPolicyAgreements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.fleet.UserAgreement, opt_index);
};


proto.fleet.UserSummary.prototype.clearPolicyAgreementsList = function() {
  this.setPolicyAgreementsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UserProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserProfile.displayName = 'proto.fleet.UserProfile';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
    userSummary: (f = msg.getUserSummary()) && proto.fleet.UserSummary.toObject(includeInstance, f),
    address: (f = msg.getAddress()) && shared_pb.Address.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0),
    accountStatus: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserProfile}
 */
proto.fleet.UserProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserProfile;
  return proto.fleet.UserProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserProfile}
 */
proto.fleet.UserProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.UserSummary;
      reader.readMessage(value,proto.fleet.UserSummary.deserializeBinaryFromReader);
      msg.setUserSummary(value);
      break;
    case 2:
      var value = new shared_pb.Address;
      reader.readMessage(value,shared_pb.Address.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {!proto.fleet.UserAccountStatus} */ (reader.readEnum());
      msg.setAccountStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserSummary();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.UserSummary.serializeBinaryToWriter
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAccountStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional UserSummary user_summary = 1;
 * @return {?proto.fleet.UserSummary}
 */
proto.fleet.UserProfile.prototype.getUserSummary = function() {
  return /** @type{?proto.fleet.UserSummary} */ (
    jspb.Message.getWrapperField(this, proto.fleet.UserSummary, 1));
};


/** @param {?proto.fleet.UserSummary|undefined} value */
proto.fleet.UserProfile.prototype.setUserSummary = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.UserProfile.prototype.clearUserSummary = function() {
  this.setUserSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserProfile.prototype.hasUserSummary = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Address address = 2;
 * @return {?proto.fleet.Address}
 */
proto.fleet.UserProfile.prototype.getAddress = function() {
  return /** @type{?proto.fleet.Address} */ (
    jspb.Message.getWrapperField(this, shared_pb.Address, 2));
};


/** @param {?proto.fleet.Address|undefined} value */
proto.fleet.UserProfile.prototype.setAddress = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.UserProfile.prototype.clearAddress = function() {
  this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserProfile.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 id = 3;
 * @return {number}
 */
proto.fleet.UserProfile.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.fleet.UserProfile.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional UserAccountStatus account_status = 4;
 * @return {!proto.fleet.UserAccountStatus}
 */
proto.fleet.UserProfile.prototype.getAccountStatus = function() {
  return /** @type {!proto.fleet.UserAccountStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.fleet.UserAccountStatus} value */
proto.fleet.UserProfile.prototype.setAccountStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.UserProfileResponse.oneofGroups_);
};
goog.inherits(proto.fleet.UserProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserProfileResponse.displayName = 'proto.fleet.UserProfileResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.UserProfileResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.UserProfileResponse.UserprofileOneOfCase = {
  USERPROFILE_ONE_OF_NOT_SET: 0,
  USERPROFILE: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.UserProfileResponse.UserprofileOneOfCase}
 */
proto.fleet.UserProfileResponse.prototype.getUserprofileOneOfCase = function() {
  return /** @type {proto.fleet.UserProfileResponse.UserprofileOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.UserProfileResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    userprofile: (f = msg.getUserprofile()) && proto.fleet.UserProfile.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserProfileResponse}
 */
proto.fleet.UserProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserProfileResponse;
  return proto.fleet.UserProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserProfileResponse}
 */
proto.fleet.UserProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.UserProfile;
      reader.readMessage(value,proto.fleet.UserProfile.deserializeBinaryFromReader);
      msg.setUserprofile(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserprofile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.UserProfile.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserProfile userprofile = 1;
 * @return {?proto.fleet.UserProfile}
 */
proto.fleet.UserProfileResponse.prototype.getUserprofile = function() {
  return /** @type{?proto.fleet.UserProfile} */ (
    jspb.Message.getWrapperField(this, proto.fleet.UserProfile, 1));
};


/** @param {?proto.fleet.UserProfile|undefined} value */
proto.fleet.UserProfileResponse.prototype.setUserprofile = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.UserProfileResponse.oneofGroups_[0], value);
};


proto.fleet.UserProfileResponse.prototype.clearUserprofile = function() {
  this.setUserprofile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserProfileResponse.prototype.hasUserprofile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.UserProfileResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.UserProfileResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.UserProfileResponse.oneofGroups_[0], value);
};


proto.fleet.UserProfileResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserProfileResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UsersRequest.displayName = 'proto.fleet.UsersRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cursor: jspb.Message.getFieldWithDefault(msg, 1, 0),
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UsersRequest}
 */
proto.fleet.UsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UsersRequest;
  return proto.fleet.UsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UsersRequest}
 */
proto.fleet.UsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCursor(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCursor();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 cursor = 1;
 * @return {number}
 */
proto.fleet.UsersRequest.prototype.getCursor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.UsersRequest.prototype.setCursor = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 operating_area_id = 2;
 * @return {number}
 */
proto.fleet.UsersRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.UsersRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UsersByIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.UsersByIdRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.UsersByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UsersByIdRequest.displayName = 'proto.fleet.UsersByIdRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.UsersByIdRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UsersByIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UsersByIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UsersByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UsersByIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: jspb.Message.getRepeatedField(msg, 1),
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UsersByIdRequest}
 */
proto.fleet.UsersByIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UsersByIdRequest;
  return proto.fleet.UsersByIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UsersByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UsersByIdRequest}
 */
proto.fleet.UsersByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setUsersList(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UsersByIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UsersByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UsersByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UsersByIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated int64 users = 1;
 * @return {!Array<number>}
 */
proto.fleet.UsersByIdRequest.prototype.getUsersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<number>} value */
proto.fleet.UsersByIdRequest.prototype.setUsersList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.fleet.UsersByIdRequest.prototype.addUsers = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.fleet.UsersByIdRequest.prototype.clearUsersList = function() {
  this.setUsersList([]);
};


/**
 * optional int32 operating_area_id = 2;
 * @return {number}
 */
proto.fleet.UsersByIdRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.UsersByIdRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.UserIdResponse.oneofGroups_);
};
goog.inherits(proto.fleet.UserIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserIdResponse.displayName = 'proto.fleet.UserIdResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.UserIdResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.UserIdResponse.UseridOneOfCase = {
  USERID_ONE_OF_NOT_SET: 0,
  USERID: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.UserIdResponse.UseridOneOfCase}
 */
proto.fleet.UserIdResponse.prototype.getUseridOneOfCase = function() {
  return /** @type {proto.fleet.UserIdResponse.UseridOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.UserIdResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserIdResponse}
 */
proto.fleet.UserIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserIdResponse;
  return proto.fleet.UserIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserIdResponse}
 */
proto.fleet.UserIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 userid = 1;
 * @return {number}
 */
proto.fleet.UserIdResponse.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.UserIdResponse.prototype.setUserid = function(value) {
  jspb.Message.setOneofField(this, 1, proto.fleet.UserIdResponse.oneofGroups_[0], value);
};


proto.fleet.UserIdResponse.prototype.clearUserid = function() {
  jspb.Message.setOneofField(this, 1, proto.fleet.UserIdResponse.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserIdResponse.prototype.hasUserid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.UserIdResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.UserIdResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.UserIdResponse.oneofGroups_[0], value);
};


proto.fleet.UserIdResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UserIdResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UserId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UserId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UserId.displayName = 'proto.fleet.UserId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UserId.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UserId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UserId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserId.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UserId}
 */
proto.fleet.UserId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UserId;
  return proto.fleet.UserId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UserId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UserId}
 */
proto.fleet.UserId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UserId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UserId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UserId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UserId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.fleet.UserId.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.UserId.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.CreateOwnUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.CreateOwnUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.CreateOwnUserRequest.displayName = 'proto.fleet.CreateOwnUserRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.CreateOwnUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.CreateOwnUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.CreateOwnUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateOwnUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 2, ""),
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.CreateOwnUserRequest}
 */
proto.fleet.CreateOwnUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.CreateOwnUserRequest;
  return proto.fleet.CreateOwnUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.CreateOwnUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.CreateOwnUserRequest}
 */
proto.fleet.CreateOwnUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.CreateOwnUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.CreateOwnUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.CreateOwnUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateOwnUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.fleet.CreateOwnUserRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.CreateOwnUserRequest.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string phone = 2;
 * @return {string}
 */
proto.fleet.CreateOwnUserRequest.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.CreateOwnUserRequest.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 operating_area_id = 3;
 * @return {number}
 */
proto.fleet.CreateOwnUserRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.fleet.CreateOwnUserRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.CreateOwnUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.CreateOwnUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.CreateOwnUserResponse.displayName = 'proto.fleet.CreateOwnUserResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.CreateOwnUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.CreateOwnUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.CreateOwnUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateOwnUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.CreateOwnUserResponse}
 */
proto.fleet.CreateOwnUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.CreateOwnUserResponse;
  return proto.fleet.CreateOwnUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.CreateOwnUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.CreateOwnUserResponse}
 */
proto.fleet.CreateOwnUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.CreateOwnUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.CreateOwnUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.CreateOwnUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateOwnUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.RequestSiteAccessRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.RequestSiteAccessRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.RequestSiteAccessRequest.displayName = 'proto.fleet.RequestSiteAccessRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.RequestSiteAccessRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.RequestSiteAccessRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.RequestSiteAccessRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RequestSiteAccessRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.RequestSiteAccessRequest}
 */
proto.fleet.RequestSiteAccessRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.RequestSiteAccessRequest;
  return proto.fleet.RequestSiteAccessRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.RequestSiteAccessRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.RequestSiteAccessRequest}
 */
proto.fleet.RequestSiteAccessRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.RequestSiteAccessRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.RequestSiteAccessRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.RequestSiteAccessRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RequestSiteAccessRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.RequestSiteAccessRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.RequestSiteAccessRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.RequestSiteAccessResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.RequestSiteAccessResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.RequestSiteAccessResponse.displayName = 'proto.fleet.RequestSiteAccessResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.RequestSiteAccessResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.RequestSiteAccessResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.RequestSiteAccessResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RequestSiteAccessResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.RequestSiteAccessResponse}
 */
proto.fleet.RequestSiteAccessResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.RequestSiteAccessResponse;
  return proto.fleet.RequestSiteAccessResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.RequestSiteAccessResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.RequestSiteAccessResponse}
 */
proto.fleet.RequestSiteAccessResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.RequestSiteAccessResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.RequestSiteAccessResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.RequestSiteAccessResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.RequestSiteAccessResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UpdateUserSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.UpdateUserSummaryRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.UpdateUserSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UpdateUserSummaryRequest.displayName = 'proto.fleet.UpdateUserSummaryRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.UpdateUserSummaryRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UpdateUserSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UpdateUserSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateUserSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 4, ""),
    allowText: jspb.Message.getFieldWithDefault(msg, 5, false),
    hasAllowText: jspb.Message.getFieldWithDefault(msg, 6, false),
    policyAgreementsList: jspb.Message.toObjectList(msg.getPolicyAgreementsList(),
    proto.fleet.UserAgreement.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UpdateUserSummaryRequest}
 */
proto.fleet.UpdateUserSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UpdateUserSummaryRequest;
  return proto.fleet.UpdateUserSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UpdateUserSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UpdateUserSummaryRequest}
 */
proto.fleet.UpdateUserSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowText(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasAllowText(value);
      break;
    case 7:
      var value = new proto.fleet.UserAgreement;
      reader.readMessage(value,proto.fleet.UserAgreement.deserializeBinaryFromReader);
      msg.addPolicyAgreements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UpdateUserSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UpdateUserSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateUserSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAllowText();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getHasAllowText();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getPolicyAgreementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.fleet.UserAgreement.serializeBinaryToWriter
    );
  }
};


/**
 * optional string first_name = 1;
 * @return {string}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.UpdateUserSummaryRequest.prototype.setFirstName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string last_name = 2;
 * @return {string}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.UpdateUserSummaryRequest.prototype.setLastName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.UpdateUserSummaryRequest.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string phone = 4;
 * @return {string}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.UpdateUserSummaryRequest.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool allow_text = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.getAllowText = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.fleet.UpdateUserSummaryRequest.prototype.setAllowText = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool has_allow_text = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.getHasAllowText = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.fleet.UpdateUserSummaryRequest.prototype.setHasAllowText = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * repeated UserAgreement policy_agreements = 7;
 * @return {!Array<!proto.fleet.UserAgreement>}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.getPolicyAgreementsList = function() {
  return /** @type{!Array<!proto.fleet.UserAgreement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.UserAgreement, 7));
};


/** @param {!Array<!proto.fleet.UserAgreement>} value */
proto.fleet.UpdateUserSummaryRequest.prototype.setPolicyAgreementsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.fleet.UserAgreement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.UserAgreement}
 */
proto.fleet.UpdateUserSummaryRequest.prototype.addPolicyAgreements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.fleet.UserAgreement, opt_index);
};


proto.fleet.UpdateUserSummaryRequest.prototype.clearPolicyAgreementsList = function() {
  this.setPolicyAgreementsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UpdateUserSummaryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UpdateUserSummaryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UpdateUserSummaryResponse.displayName = 'proto.fleet.UpdateUserSummaryResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UpdateUserSummaryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UpdateUserSummaryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UpdateUserSummaryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateUserSummaryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountStatus: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UpdateUserSummaryResponse}
 */
proto.fleet.UpdateUserSummaryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UpdateUserSummaryResponse;
  return proto.fleet.UpdateUserSummaryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UpdateUserSummaryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UpdateUserSummaryResponse}
 */
proto.fleet.UpdateUserSummaryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fleet.UserAccountStatus} */ (reader.readEnum());
      msg.setAccountStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UpdateUserSummaryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UpdateUserSummaryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UpdateUserSummaryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateUserSummaryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional UserAccountStatus account_status = 1;
 * @return {!proto.fleet.UserAccountStatus}
 */
proto.fleet.UpdateUserSummaryResponse.prototype.getAccountStatus = function() {
  return /** @type {!proto.fleet.UserAccountStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.fleet.UserAccountStatus} value */
proto.fleet.UpdateUserSummaryResponse.prototype.setAccountStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.OpAreaApprovalStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.OpAreaApprovalStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.OpAreaApprovalStatus.displayName = 'proto.fleet.OpAreaApprovalStatus';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.OpAreaApprovalStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.OpAreaApprovalStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.OpAreaApprovalStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OpAreaApprovalStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userApprovalStatus: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.OpAreaApprovalStatus}
 */
proto.fleet.OpAreaApprovalStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.OpAreaApprovalStatus;
  return proto.fleet.OpAreaApprovalStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.OpAreaApprovalStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.OpAreaApprovalStatus}
 */
proto.fleet.OpAreaApprovalStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 1:
      var value = /** @type {!proto.fleet.UserApprovalStatus} */ (reader.readEnum());
      msg.setUserApprovalStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.OpAreaApprovalStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.OpAreaApprovalStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.OpAreaApprovalStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.OpAreaApprovalStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getUserApprovalStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 2;
 * @return {number}
 */
proto.fleet.OpAreaApprovalStatus.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.OpAreaApprovalStatus.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional UserApprovalStatus user_approval_status = 1;
 * @return {!proto.fleet.UserApprovalStatus}
 */
proto.fleet.OpAreaApprovalStatus.prototype.getUserApprovalStatus = function() {
  return /** @type {!proto.fleet.UserApprovalStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.fleet.UserApprovalStatus} value */
proto.fleet.OpAreaApprovalStatus.prototype.setUserApprovalStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetApprovalStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.GetApprovalStatusResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.GetApprovalStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetApprovalStatusResponse.displayName = 'proto.fleet.GetApprovalStatusResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.GetApprovalStatusResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetApprovalStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetApprovalStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetApprovalStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetApprovalStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    opAreaApprovalStatusList: jspb.Message.toObjectList(msg.getOpAreaApprovalStatusList(),
    proto.fleet.OpAreaApprovalStatus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetApprovalStatusResponse}
 */
proto.fleet.GetApprovalStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetApprovalStatusResponse;
  return proto.fleet.GetApprovalStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetApprovalStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetApprovalStatusResponse}
 */
proto.fleet.GetApprovalStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.OpAreaApprovalStatus;
      reader.readMessage(value,proto.fleet.OpAreaApprovalStatus.deserializeBinaryFromReader);
      msg.addOpAreaApprovalStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetApprovalStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetApprovalStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetApprovalStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetApprovalStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpAreaApprovalStatusList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.OpAreaApprovalStatus.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OpAreaApprovalStatus op_area_approval_status = 1;
 * @return {!Array<!proto.fleet.OpAreaApprovalStatus>}
 */
proto.fleet.GetApprovalStatusResponse.prototype.getOpAreaApprovalStatusList = function() {
  return /** @type{!Array<!proto.fleet.OpAreaApprovalStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.OpAreaApprovalStatus, 1));
};


/** @param {!Array<!proto.fleet.OpAreaApprovalStatus>} value */
proto.fleet.GetApprovalStatusResponse.prototype.setOpAreaApprovalStatusList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.OpAreaApprovalStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.OpAreaApprovalStatus}
 */
proto.fleet.GetApprovalStatusResponse.prototype.addOpAreaApprovalStatus = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.OpAreaApprovalStatus, opt_index);
};


proto.fleet.GetApprovalStatusResponse.prototype.clearOpAreaApprovalStatusList = function() {
  this.setOpAreaApprovalStatusList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UpdateApprovalStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UpdateApprovalStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UpdateApprovalStatusRequest.displayName = 'proto.fleet.UpdateApprovalStatusRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UpdateApprovalStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UpdateApprovalStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UpdateApprovalStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateApprovalStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: (f = msg.getUserId()) && proto.fleet.UserId.toObject(includeInstance, f),
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    approvalStatus: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UpdateApprovalStatusRequest}
 */
proto.fleet.UpdateApprovalStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UpdateApprovalStatusRequest;
  return proto.fleet.UpdateApprovalStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UpdateApprovalStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UpdateApprovalStatusRequest}
 */
proto.fleet.UpdateApprovalStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.UserId;
      reader.readMessage(value,proto.fleet.UserId.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 3:
      var value = /** @type {!proto.fleet.UserApprovalStatus} */ (reader.readEnum());
      msg.setApprovalStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UpdateApprovalStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UpdateApprovalStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UpdateApprovalStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateApprovalStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.UserId.serializeBinaryToWriter
    );
  }
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getApprovalStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional UserId user_id = 1;
 * @return {?proto.fleet.UserId}
 */
proto.fleet.UpdateApprovalStatusRequest.prototype.getUserId = function() {
  return /** @type{?proto.fleet.UserId} */ (
    jspb.Message.getWrapperField(this, proto.fleet.UserId, 1));
};


/** @param {?proto.fleet.UserId|undefined} value */
proto.fleet.UpdateApprovalStatusRequest.prototype.setUserId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.UpdateApprovalStatusRequest.prototype.clearUserId = function() {
  this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.UpdateApprovalStatusRequest.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 operating_area_id = 2;
 * @return {number}
 */
proto.fleet.UpdateApprovalStatusRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.UpdateApprovalStatusRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional UserApprovalStatus approval_status = 3;
 * @return {!proto.fleet.UserApprovalStatus}
 */
proto.fleet.UpdateApprovalStatusRequest.prototype.getApprovalStatus = function() {
  return /** @type {!proto.fleet.UserApprovalStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.fleet.UserApprovalStatus} value */
proto.fleet.UpdateApprovalStatusRequest.prototype.setApprovalStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UpdateApprovalStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UpdateApprovalStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UpdateApprovalStatusResponse.displayName = 'proto.fleet.UpdateApprovalStatusResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UpdateApprovalStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UpdateApprovalStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UpdateApprovalStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateApprovalStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UpdateApprovalStatusResponse}
 */
proto.fleet.UpdateApprovalStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UpdateApprovalStatusResponse;
  return proto.fleet.UpdateApprovalStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UpdateApprovalStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UpdateApprovalStatusResponse}
 */
proto.fleet.UpdateApprovalStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UpdateApprovalStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UpdateApprovalStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UpdateApprovalStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateApprovalStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UpdatePushTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UpdatePushTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UpdatePushTokenRequest.displayName = 'proto.fleet.UpdatePushTokenRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UpdatePushTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UpdatePushTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UpdatePushTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdatePushTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tokenType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pushToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UpdatePushTokenRequest}
 */
proto.fleet.UpdatePushTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UpdatePushTokenRequest;
  return proto.fleet.UpdatePushTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UpdatePushTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UpdatePushTokenRequest}
 */
proto.fleet.UpdatePushTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fleet.PushTokenType} */ (reader.readEnum());
      msg.setTokenType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPushToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UpdatePushTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UpdatePushTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UpdatePushTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdatePushTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTokenType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPushToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional PushTokenType token_type = 1;
 * @return {!proto.fleet.PushTokenType}
 */
proto.fleet.UpdatePushTokenRequest.prototype.getTokenType = function() {
  return /** @type {!proto.fleet.PushTokenType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.fleet.PushTokenType} value */
proto.fleet.UpdatePushTokenRequest.prototype.setTokenType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string push_token = 2;
 * @return {string}
 */
proto.fleet.UpdatePushTokenRequest.prototype.getPushToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.UpdatePushTokenRequest.prototype.setPushToken = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UpdatePushTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UpdatePushTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UpdatePushTokenResponse.displayName = 'proto.fleet.UpdatePushTokenResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UpdatePushTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UpdatePushTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UpdatePushTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdatePushTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UpdatePushTokenResponse}
 */
proto.fleet.UpdatePushTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UpdatePushTokenResponse;
  return proto.fleet.UpdatePushTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UpdatePushTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UpdatePushTokenResponse}
 */
proto.fleet.UpdatePushTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UpdatePushTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UpdatePushTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UpdatePushTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdatePushTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetUserMetadataByIdData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.GetUserMetadataByIdData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetUserMetadataByIdData.displayName = 'proto.fleet.GetUserMetadataByIdData';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetUserMetadataByIdData.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetUserMetadataByIdData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetUserMetadataByIdData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetUserMetadataByIdData.toObject = function(includeInstance, msg) {
  var f, obj = {
    firebaseUid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    allowNotifications: jspb.Message.getFieldWithDefault(msg, 2, false),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetUserMetadataByIdData}
 */
proto.fleet.GetUserMetadataByIdData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetUserMetadataByIdData;
  return proto.fleet.GetUserMetadataByIdData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetUserMetadataByIdData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetUserMetadataByIdData}
 */
proto.fleet.GetUserMetadataByIdData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirebaseUid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowNotifications(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetUserMetadataByIdData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetUserMetadataByIdData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetUserMetadataByIdData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetUserMetadataByIdData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirebaseUid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAllowNotifications();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string firebase_uid = 1;
 * @return {string}
 */
proto.fleet.GetUserMetadataByIdData.prototype.getFirebaseUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.GetUserMetadataByIdData.prototype.setFirebaseUid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool allow_notifications = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.GetUserMetadataByIdData.prototype.getAllowNotifications = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.fleet.GetUserMetadataByIdData.prototype.setAllowNotifications = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string phone_number = 3;
 * @return {string}
 */
proto.fleet.GetUserMetadataByIdData.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.GetUserMetadataByIdData.prototype.setPhoneNumber = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.fleet.GetUserMetadataByIdData.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.GetUserMetadataByIdData.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 user_id = 5;
 * @return {number}
 */
proto.fleet.GetUserMetadataByIdData.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.fleet.GetUserMetadataByIdData.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetUserMetadataByIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.GetUserMetadataByIdRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.GetUserMetadataByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetUserMetadataByIdRequest.displayName = 'proto.fleet.GetUserMetadataByIdRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.GetUserMetadataByIdRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetUserMetadataByIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetUserMetadataByIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetUserMetadataByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetUserMetadataByIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    firebaseUidList: jspb.Message.getRepeatedField(msg, 1)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetUserMetadataByIdRequest}
 */
proto.fleet.GetUserMetadataByIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetUserMetadataByIdRequest;
  return proto.fleet.GetUserMetadataByIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetUserMetadataByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetUserMetadataByIdRequest}
 */
proto.fleet.GetUserMetadataByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFirebaseUid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetUserMetadataByIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetUserMetadataByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetUserMetadataByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetUserMetadataByIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirebaseUidList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string firebase_uid = 1;
 * @return {!Array<string>}
 */
proto.fleet.GetUserMetadataByIdRequest.prototype.getFirebaseUidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<string>} value */
proto.fleet.GetUserMetadataByIdRequest.prototype.setFirebaseUidList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.fleet.GetUserMetadataByIdRequest.prototype.addFirebaseUid = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.fleet.GetUserMetadataByIdRequest.prototype.clearFirebaseUidList = function() {
  this.setFirebaseUidList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetUserMetadataByIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.GetUserMetadataByIdResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.GetUserMetadataByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetUserMetadataByIdResponse.displayName = 'proto.fleet.GetUserMetadataByIdResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.GetUserMetadataByIdResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetUserMetadataByIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetUserMetadataByIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetUserMetadataByIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetUserMetadataByIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.fleet.GetUserMetadataByIdData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetUserMetadataByIdResponse}
 */
proto.fleet.GetUserMetadataByIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetUserMetadataByIdResponse;
  return proto.fleet.GetUserMetadataByIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetUserMetadataByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetUserMetadataByIdResponse}
 */
proto.fleet.GetUserMetadataByIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.GetUserMetadataByIdData;
      reader.readMessage(value,proto.fleet.GetUserMetadataByIdData.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetUserMetadataByIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetUserMetadataByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetUserMetadataByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetUserMetadataByIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.GetUserMetadataByIdData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GetUserMetadataByIdData data = 1;
 * @return {!Array<!proto.fleet.GetUserMetadataByIdData>}
 */
proto.fleet.GetUserMetadataByIdResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.fleet.GetUserMetadataByIdData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.GetUserMetadataByIdData, 1));
};


/** @param {!Array<!proto.fleet.GetUserMetadataByIdData>} value */
proto.fleet.GetUserMetadataByIdResponse.prototype.setDataList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.GetUserMetadataByIdData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.GetUserMetadataByIdData}
 */
proto.fleet.GetUserMetadataByIdResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.GetUserMetadataByIdData, opt_index);
};


proto.fleet.GetUserMetadataByIdResponse.prototype.clearDataList = function() {
  this.setDataList([]);
};


/**
 * @enum {number}
 */
proto.fleet.UserAccountStatus = {
  UNKNOWN: 0,
  MISSING_EMAIL: 1,
  MISSING_PHONE: 2,
  MISSING_NAME: 3,
  COMPLETED_SIGNUP: 4
};

/**
 * @enum {number}
 */
proto.fleet.PolicyAgreementTypes = {
  POLICY_UNKNOWN: 0,
  POLICY_PRIVACY: 1,
  POLICY_TERMS: 2,
  POLICY_ACCEPT_SMS: 3
};

/**
 * @enum {number}
 */
proto.fleet.UserApprovalStatus = {
  UNKNOWN_STATUS: 0,
  PENDING: 1,
  APPROVED: 2,
  DENIED: 3
};

/**
 * @enum {number}
 */
proto.fleet.PushTokenType = {
  UNKNOWN_TOKEN: 0,
  FCM: 1,
  APNS: 2
};

goog.object.extend(exports, proto.fleet);
